import React from "react";
import { TodoContext } from "../TodoContext";
import { PlusIcon } from "@heroicons/react/24/outline";

function CreateTodoButtom() {
  const { openModal, setOpenModal } = React.useContext(TodoContext);

  return (
    <button
      className={`${
        openModal ? "rotate-45" : ""
      } z-20 hover:bg-violet-400 bg-violet-500 text-white rounded-full text-3xl absolute bottom-4 right-4 transition-all`}
      onClick={() => {
        setOpenModal(!openModal);
      }}
    >
      <PlusIcon className="h-8 w-8 m-2" aria-hidden="true" />
    </button>
  );
}

export { CreateTodoButtom };
